import userSlice from 'data/user/index';

export default userSlice.actions.receiveUsers;
